import React from 'react'
// components
import { LoaderWithOverlay } from 'components/UI/Loader'
// view components
import Content from 'components/Modals/PlanItems/components/ActivitiesList/components/SubActivitiesList/components/SubActivitiesContent'
// context
import { ActivitiesListAPIContext } from 'containers/Activities/layers/API/ActivitiesList'

const SubActivitiesList: React.FC = () => {
  const { refetch, loading, entity } = React.useContext(ActivitiesListAPIContext)

  return loading ? <LoaderWithOverlay isLoading={loading} /> : <Content disableDrag refetch={refetch} entity={entity} />
}

export default SubActivitiesList
